import { globalPerf } from './perf';
import { createMeasure } from './measure';

const START_PREFIX = 'tcc_start_';
const END_PREFIX = 'tcc_end_';

/**
 * @param {String} name
 * @return {Object} Mark
 */
function getMark(name) {
  if (!globalPerf.getEntriesByName) {
    return null;
  }

  return globalPerf.getEntriesByName(name, 'mark')[0];
}

/**
 * @param {String} name Mark Name
 * @return {Object} created mark
 */
function createMark(name) {
  if (!globalPerf.mark) {
    return null;
  }

  globalPerf.mark(name);
  return getMark(name);
}

/**
 * Creates an start mark for the given metric name
 * @param {String} name
 * @return {Boolean} Has the metric been created?
 */
export function start(name) {
  return createMark(START_PREFIX + name);
}

/**
 * Creates and End mark for the given mark name and creates a measure
 * @param {String} name
 * @return {String}
 */
export function end(name) {
  const startMark = getMark(START_PREFIX + name);
  const markName = END_PREFIX + name;

  // Only create an end mark if a start mark exists
  if (!startMark) {
    return null;
  }

  createMark(markName);
  createMeasure(name, startMark.name, markName);
  return getMark(markName);
}
